<template>
    <div>
        <!-- Modal Troca Médico -->
        <div class="modal fade" id="trocaMedicoCompModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            Selecionar Profissional
                            <span class="badge badge-secondary" v-if="compartilhada">
                                C 
                            </span>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="alert alert-info">
                            {{ origem ? origem.search : 'Aguarde...' }}
                        </div>

                        <div class="mb-3">
                            <az-input
                                type="select"
                                icon="fas fa-user-md fa-fw"
                                placeholder="Selecione o Profissional..."
                                :optionsList="lista_medicos_filtrada"
                                optionsData="id_pessoa"
                                required
                                :validate="validate"
                                v-model="novo_medico" />
                        </div>

                        <div class="row">
                            <div class="col col-12">
                                <table class="table">
                                    <thead>
                                        <tr>
                                            <th>
                                                <a type="button" class="card-link text-primary" @click.prevent="toggle_selec_all()" >
                                                    Todos
                                                </a>
                                            </th>
                                            <th>Data</th>
                                            <th>Hora</th>
                                            <th>Paciente</th>
                                            <th>Procedimento</th>
                                            <th>Profissional</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, iix) in lista" :key="iix">
                                            <td width="1%">
                                                <input type="checkbox" v-model="item.selecionado" />
                                            </td>
                                            <td>
                                                {{ $util.getFormatDate(item.marcacao.dt_inicio) }} 
                                            </td>
                                            <td>
                                                {{ item.marcacao.dt_inicio.slice(11,16) }} 
                                            </td>
                                            <td>{{ item.marcacao.nome_paciente }}</td>
                                            <td>{{ item.marcacao.procedimento.search }}</td>
                                            <td><span v-if="item.marcacao.medico_comp">{{ item.marcacao.medico_comp.search }}</span></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                        <az-submit @click="atualizar()">Atualizar</az-submit>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzInput from "../../shared/forms/AzInput.vue";
import AzSubmit from '../../util/AzSubmit.vue';

export default {
    data() {
        return { 
            lista: [], 
            lista_medicos_comp: null, 
            novo_medico: "", 
            origem: null, 
            validate: false, 
            compartilhada: true, 
            auxiliar: false, 
        }
    },

    components: { 
        AzInput, 
        AzSubmit,
    },

    props: ['lista_medicos'],

    computed: { 
        lista_medicos_filtrada: function () { 
            if ( !this.lista_medicos )
                return [];

            if ( !this.compartilhada ) {
                return this.lista_medicos.filter(item => !item.fl_agenda_compartilhada);
            }

            return this.lista_medicos.filter(item => !item.fl_agenda_compartilhada && this.lista_medicos_comp && this.lista_medicos_comp[item.id_pessoa]);
        } 
    },

    methods: { 
        toggle_selec_all () { 
            let selec = this.lista.find(item => !item.selecionado) ? true : false;

            this.lista.forEach(item => { 
                item.selecionado = selec; 
            });
        },

        atualizar () { 
            this.$util.atualizar(this, { 
                service: 'agendas',
                func: 'atualizar_medico_comp', 
                dados: { 
                    lista: this.lista.filter(item => item.selecionado).map(item => item.marcacao.id_marcacao), 
                    id_medico_comp: this.novo_medico, 
                    compartilhada: this.compartilhada,
                    auxiliar: this.auxiliar,
                },
                callback: () => { 
                    $('#trocaMedicoCompModal').modal('hide');
                    this.$emit('refresh');
                }
            });
        },

        abrir(lista, id_medico, compartilhada = true, auxiliar = false) { 
            this.validate = false;
            this.novo_medico = ""; 
            this.origem = null;
            this.compartilhada = compartilhada;
            this.auxiliar = auxiliar;
            this.lista_medicos_comp = null; 

            //

            let query = {
                q: [
                    {
                        name: 'medicos.show',
                        id: "medico",
                        parms: {
                            id: id_medico,
                        }
                    },
                    {
                        name: 'medicos.lista',
                        id: "lista",
                        parms: {
                            id: id_medico,
                            model: 'medico', 
                        }
                    }
                ],
            };

            this.axios.post("/aql", query)
                .then(res => {
                    if (res.data.medico && res.data.medico.status == 200) {
                        this.origem = res.data.medico.data;
                    }

                    if (res.data.lista.status == 200) {
                        this.lista_medicos_comp = _.mapKeys(res.data.lista.data.medico_lista, item => item.id_medico); 
                    }
                });

            //

            // item.marcacao.medico_comp && item.marcacao.id_medico_comp &&
            let lista_selec = _.cloneDeep(lista.filter(item => item.marcacao && item.marcacao.ch_estado_marcacao == 'A' && !item.marcacao.id_atendimento)); 

            lista_selec.forEach(item => { 
                item.selecionado = true; 
            });

            this.lista = lista_selec;

            $('#trocaMedicoCompModal').modal('show');
        }
    }
}
</script>
